import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'me',
      component:  () => import('./views/me.vue')
    },
    {
      path: '/activities',
      name: 'categories',
      component: () => import( './views/temp.vue'),
      alias:['/projects','/education']
    },
    {
      path: '/activities/:ID',
      name: 'unique',
      component: () => import( './views/tempinfo.vue'),
      alias:['/projects/:ID','/education/:ID']
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import( './views/admin.vue')
    },
    {
      path: '/space',
      name: 'space',
      component: () => import( './views/space.vue')
    },
    {
      path: '/card_game',
      name: 'unripe flower',
      component: () => import( './views/cardGame.vue')
    },
    {
      path: '/404',
      name: '404',
      component: () => import( './views/notFound.vue')
    },
    { path: '*', redirect: '/404' }

  ],
  mode:'history'
})
